import React from 'react'

import { TextClamp } from '../components/text/TextClamp'
import { EditableText } from '../slides/EditableText'
import type { VisibleTextClampProps } from '../foundations/text-limits'

/**
 * The narrative slot (plots plan Stage 2, AA): a slide's subtitle (actionSubtitle, 20px), clamped to
 * its line budget (`TextClamp`), or an `EditableText` in edit mode. `children` is what
 * the clamp draws (plain text, or text with inline bold); `value` is what edit mode
 * edits. `renderMode` reaches the clamp so a static (PDF) render keeps its own rules.
 */
export interface SlotNarrativeProps {
  value: string
  children?: React.ReactNode
  clamp: Pick<VisibleTextClampProps, 'minLines' | 'maxLines' | 'lineHeight'>
  color?: string
  /** Extra layout style on the clamp (a margin, a fixed width), as the host places it. */
  style?: React.CSSProperties
  testId?: string
  /** The clamp may shrink in its column (matrix-rating's); by default it keeps every line. */
  shrink?: boolean
  editable?: boolean
  onEdit?: (field: string, value: string) => void
  renderMode?: 'interactive' | 'static'
}

export function SlotNarrative(props: SlotNarrativeProps) {
  const { value, clamp, color = 'var(--slide-text-primary)', style, testId, shrink, editable, onEdit, renderMode } = props
  if (editable && onEdit) {
    return <EditableText value={value} field="actionSubtitle" editable onEdit={onEdit} tag="p" style={{ fontSize: 20, color }} />
  }
  return (
    <TextClamp
      data-testid={testId}
      minLines={clamp.minLines}
      maxLines={clamp.maxLines}
      lineHeight={clamp.lineHeight}
      renderMode={renderMode}
      style={{ ...style, fontSize: 20, color, ...(shrink ? {} : { flexShrink: 0 }) }}
    >
      {props.children ?? value}
    </TextClamp>
  )
}
